<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        placeholder="请选择状态"
        size="small"
        clearable
      >
        <el-option
          v-for="item in optionArr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-input
        v-model="query.fBillNo"
        placeholder="单据编号"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fDistributorName"
        placeholder="经销商"
        size="small"
        style="width: 200px"
        clearable
      />

      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <!-- <el-button
        v-if="canAdd"
        type="primary"
        size="small"
        @click="_modify(null)"
      >添加</el-button> -->
      <!-- <el-button type="primary" size="small" @click="delSystemPeople">删除</el-button> -->
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="_modify"
      >
        <el-table-column prop="fBillNo" label="单据编号" min-width="110" />
        <el-table-column prop="fDistributorName" label="供应商" min-width="280" />

        <el-table-column prop="fMoney_zz" label="转账金额" />
        <el-table-column prop="fMoney_jk" label="代扣金额(借款)" />
        <el-table-column prop="fPay" label="付款单位名称" min-width="280" />
        <el-table-column prop="fState" label="状态" />
        <el-table-column
          prop="fCreateTime"
          label="制单时间"
          :formatter="dateFormat"
          min-width="160"
        />
        <el-table-column label="操作" class-name="table-oper-col">
          <template slot-scope="scope">
            <template>
              <el-button
                type="text"
                size="small"
                @click="_modify(scope.row)"
              >查看</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import EditForm from './EditForm'
import { Today } from '@assets/site'
// import readForm from './readForm'
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    EditForm,
    ConfirmButton
  },
  data() {
    return {
      query: {
        fState: '未提交',
        fDistributorName: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,
      tableData: [],
      loading: false,
      optionArr: [
        {
          label: '未提交',
          value: '未提交'
        },
        {
          label: '已提交',
          value: '已提交'
        }
      ],
      ts: null,
      currentEditItem: null
    }
  },
  activated() {
    // this.refresh();
    // console.log(this.$route.query, 'this.$route.query')
    if (this.ts == this.$route.query.ts) {
      console.log('of coures')
    } else {
      const val = this.$route.query
      this._modify(val)
      this.ts = this.$route.query.ts
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    // 获取快递公司列表
    refresh() {
      this.loading = true
      this.$httpPost(
        'RechargeManage/RechargeForWl/RechargeForWlEntry',
        this.query
      )
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    // 查看接口
    _read: async function(row) {
      //   this.currentreadItem = await this.$httpPost(
      //     'RechargeManage/Recharge/RechargeModify',
      //     { fBillNo: row.fBillNo }
      //   ).then((res) => res.datalist)
      //   const h = this.$createElement
      //   this.$formDlg({
      //     title: '查看月度销售额',
      //     formTpl: <readForm form={this.currentreadItem}></readForm>,
      //     formSubmit: (formData) => this.readpostData(formData),
      //     width: '50%',
      //     readonly: !this.canAdd
      //   })
    },
    readpostData(modifyType, info) {
      return this.$httpPost(
        `BasicInformation/DistributorQuota/SaveMonthQuota`,
        {
          datalist: JSON.stringify({
            ...modifyType,
            info
          })
        }
      ).then(async(res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    // 新增经销商
    _modify: async function(row) {
      // console.log(row, 'row')

      this.currentEditItem = await this.$httpPost(
        'RechargeManage/RechargeForWl/GetRechargeForWl',
        { fid: row.fid }
      ).then((res) => res.datalist)
      this.currentEditItem.list = await this.$httpPost(
        'BasicInformation/Distributor/DistributorChoiceEntry',
        { prohibit: true }
      ).then((res) => res.datalist)

      const h = this.$createElement
      this.$formDlg({
        title: '查看充值单',
        width: '50%',
        formTpl: <EditForm form={this.currentEditItem}></EditForm>,
        formSubmit: (formData) => this.postData(formData),
        formClose: () => {
          this.refresh()
        },
        readonly: true
      })
    },

    postData(modifyType) {
      // console.log(modifyType, 'modifyType')
      delete modifyType.list
      return this.$httpPost(
        `RechargeManage/RechargeForWl/RechargeForWlApproval`,
        {
          datalist: JSON.stringify({ ...modifyType })
        }
      ).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="">
</style>
